import { Tag } from "antd";
import {
  QueryOperation,
  SearchQuery,
} from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import { DynamicSchema } from "../controls/DynamicForm.default";
import { InputObject } from "../controls/default";
import {
  buildSearchQuery,
  comboboxValue,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";

export interface BadgesViewForm {
  readonly name: string;
  readonly code: string;
  readonly triggerEvent: InputObject;
  readonly isActive: boolean;
}

export const badgesViewColumns: DataColumn[] = [
  {
    title: "Code",
    key: "code",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
  },
  {
    title: "Description",
    key: "description",
    width: 240,
    sort: true,
  },
  {
    // Achievement criteria: which engagement event auto-awards this badge (null = manual only).
    title: "Trigger",
    key: "triggerEvent",
    width: 180,
    sort: true,
    transform: (value: string) =>
      value ? <Tag color="purple">{value}</Tag> : "—",
  },
  {
    title: "Threshold",
    key: "threshold",
    width: 110,
    sort: true,
    type: "badge",
  },
  {
    title: "Point reward",
    key: "pointReward",
    width: 120,
    sort: true,
    type: "badge",
  },
  {
    title: "Active",
    key: "isActive",
    width: 110,
    sort: true,
    transform: (value: boolean) => (
      <Tag color={value ? "green" : "default"}>
        {value ? "Active" : "Inactive"}
      </Tag>
    ),
  },
  {
    title: "Companies",
    key: "badgedCompaniesCount",
    width: 120,
    sort: true,
    type: "badge",
  },
  {
    title: "Departments",
    key: "badgedDepartmentsCount",
    width: 130,
    sort: true,
    type: "badge",
  },
  {
    title: "Users",
    key: "badgedUsersCount",
    width: 100,
    sort: true,
    type: "badge",
  },
];

const badgesQueryMappings: QueryFieldMapping[] = [
  { formField: "name", operation: QueryOperation.Contains },
  { formField: "code", operation: QueryOperation.Contains },
  {
    formField: "triggerEvent",
    operation: QueryOperation.Equal,
    transform: comboboxValue,
  },
  { formField: "isActive", operation: QueryOperation.Equal },
];

export const mapBadgesViewQuery = (values: BadgesViewForm): SearchQuery =>
  buildSearchQuery(values, badgesQueryMappings);

export const badgesSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "textbox", name: "name", label: "Name" },
        { type: "textbox", name: "code", label: "Code" },
        {
          type: "combobox",
          name: "triggerEvent",
          label: "Trigger",
          request: () =>
            Promise.resolve([
              { display: "Login", value: "Login" },
              {
                display: "Questionnaire Completed",
                value: "QuestionnaireCompleted",
              },
            ]),
        },
        { type: "togglebox", name: "isActive", label: "Active" },
      ],
    },
  ],
};
